const expInfoData = {
    stockYear: '',
    stockAverageSize: '',
    stockAverageNumber: '',
    optionYear: '',
    optionAverageSize: '',
    optionAverageNumber: '',
    invest_obj: '',
};

const SET_EXP_INFO = 'SET_EXP_INFO';

export const setExpInfoData = (expInfoData) => ({
    type: SET_EXP_INFO,
    payload: expInfoData,
});

const exp_store = (state = expInfoData, action) => {
    switch (action.type) {
        case SET_EXP_INFO:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default exp_store;
